import { render, staticRenderFns } from "./cityGroupList.vue?vue&type=template&id=b1945bc0&scoped=true"
import script from "./cityGroupList.vue?vue&type=script&lang=js"
export * from "./cityGroupList.vue?vue&type=script&lang=js"
import style0 from "./cityGroupList.vue?vue&type=style&index=0&id=b1945bc0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1945bc0",
  null
  
)

export default component.exports